<script setup lang="ts">
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";
import { useLongPressTooltip } from "@/composable/useLongPressTooltip";
import { usePhotoMarkerShape } from "@/composable/usePhotoMarkerShape";

const { refHook } = useLongPressTooltip();
const { hasMultipleMarkers, currentMarkerIcon, toggleShape } =
  usePhotoMarkerShape();
</script>
<template>
  <button
    v-if="hasMultipleMarkers"
    ref="refHook"
    type="button"
    class="marker-shape-btn text-white"
    :aria-label="$t('canvas:tools.photo.changeStyle')"
    :data-bs-content="$t('canvas:tools.photomarker.tooltip.text')"
    :data-bs-title="$t('canvas:tools.photomarker.tooltip.title')"
    @click="toggleShape()"
  >
    <phosphor-icon
      :name="currentMarkerIcon"
      :size="16"
      weight="bold"
      class="opacify-70"
    />
  </button>
</template>

<style lang="scss" scoped>
.marker-shape-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 30px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background-color: transparent;
  touch-action: none;

  &:hover {
    background-color: var(--canvas-bg-hover);
  }
}
</style>
